import { useState, useEffect } from 'react';
import { RedriveApiFactory } from '../../../lusca-search-api/LuscaSearchApiFactory';

interface OrderItem {
  orderId: string;
  stage: string;
}

export const useRedriveOrdersData = (selectedStage: string, executionId: string | null) => {
  const [orders, setOrders] = useState<OrderItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  // Fetch the list of order IDs and create basic order items
  useEffect(() => {
    const fetchOrders = async () => {
      if (!executionId) {
        setOrders([]);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const redriveApi = RedriveApiFactory();
        const response = await redriveApi.getRedriveOrders(executionId, selectedStage);

        if (response.data && response.data.orders) {
          const basicOrders = response.data.orders.map((orderId: string) => ({
            orderId,
            stage: selectedStage,
          }));
          setOrders(basicOrders);
        } else {
          setOrders([]);
        }
      } catch (error) {
        setError(`Failed to load orders for this redrive execution: ${error instanceof Error ? error.message : String(error)}`);
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    if (selectedStage && executionId) {
      fetchOrders();
    }
  }, [selectedStage, executionId]);


  return { orders, loading, error };
};
